/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_KEY } from "../res/values/values";
import ChargeContent from "../components/PagesComponents/ChargeContent";
import styled from "styled-components";
import CircularProgress from '@mui/material/CircularProgress';
import { colors,API_URL } from "../res/values/values";
import { useNavigate } from "react-router-dom";
const Container = styled.div`
  align-items: center;
  width:20rem ;
  min-height:20rem ;
 
`;
const Payment = styled.div`
   
    width:100% ;
    & p {
        color:${colors.primaryColor};
        font-size:1.4rem ;
        font-weight:600 ;
        text-align:center ;
    }
 
`;
const Charge = ({totalPayment,confirmOrderWithPayment,user}) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("wait");

  const [options, setOptions] = useState({});
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  let test =""
  const appearance = {
    theme: "stripe",
  };

  useEffect(() => {
    const getClinetSecret = async () => {
      try {
        let bdy =  JSON.stringify({ amount: parseInt(totalPayment()*100) })
        const access_token = localStorage.getItem("access_token");
        let url = `${process.env.REACT_APP_API}/charge/secure`;
        await fetch(url, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer: ${access_token}`,
          },
          body:bdy,
        })
          .then((res) => res.json())
          .then((res) => {
            if(res.success === false && res.success !== undefined){
              setStatus("error")
              if (
                res.message === "You are not authorization to access this route"
              ) {
                navigate("/account/login");
              }
            }else{
              test =res.id
            
              setOptions({
                clientSecret: res.client_secret,
                appearance: appearance,
              });
              setStatus("ready");
            }
            
          })
          .catch((err) => {
            let error = JSON.parse(err.message);
            setStatus("error")
          });
      } catch (error) {
      }
    };
    getClinetSecret();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    return () => {
      if (status !== "success" && status !== "error") cancelPayment();
    };
  }, []);
  const cancelPayment = async () => {
    try {
      
      let url = `${process.env.REACT_APP_API}/charge/cancel`;
      await fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({ id: test }),
      })
        .then((res) => res.json())
        .then((res) => {
        })
        .catch((err) => {
          let error = JSON.parse(err.message);
        });
    } catch (error) {
    }
  };
  return (
    <Container>
      {status === "ready" ? (
        <Elements stripe={stripePromise} options={options}>
           <Payment><p>Total : £ {totalPayment()}</p></Payment> 
          <ChargeContent
            totalPayment={totalPayment}
            confirmOrderWithPayment={confirmOrderWithPayment}
            user={user}
          />
        </Elements>
      ) : (
        <div>
            <CircularProgress></CircularProgress>
        </div>
      )}
    </Container>
  );
};
export default Charge;
